import { Box } from '@material-ui/core';

import { Font } from '@/components/shared/components/Font';
import { Icon } from '@/components/shared/components/Icon';
import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';

export const NoUsersFound = () => {
  const { customBorderRadius, palette } = useCustomTheme();

  return (
    <Box
      display={'flex'}
      justifyContent={'center'}
      alignItems={'center'}
      minHeight={'80px'}
      borderRadius={customBorderRadius.paper}
      width={'100%'}
      bgcolor={palette.grey[100]}
    >
      <Icon color={palette.grey[500]} style={{ marginRight: '6px' }}>
        {'person_off'}
      </Icon>
      <Font variant="subtitle2" color="textSecondary">
        <Text tId={'NO_USERS_FOUND'} />
      </Font>
    </Box>
  );
};
